import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { DataService } from 'src/app/Services/Data/data.service';
import { DocumentGroup } from 'src/app/Services/Data/data.model';
import { Salesforce } from 'src/app/Services/Data/data.model';
import { GoogleAnalyticsService } from './Services/google-analytics.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  hideBar = false;
  @Input() data;
  document_group: DocumentGroup = new DocumentGroup();
  salesforce: Salesforce = new Salesforce();
  view: any = '';
  salesforce_session_data: any;

  constructor(private dataService: DataService, private GA: GoogleAnalyticsService, private router: Router) {}

  async ngOnInit() {
    // subscribe to the ga posts
    this.GA.subscribe();

    this.salesforce_session_data = await this.dataService
      .apiGetCall('/api/salesforce_session_data')
      .toPromise();

    if (this.salesforce_session_data && this.salesforce_session_data.is_maintenance) {
      this.router.navigate(['maintenance']);
      return;
    }

    this.view = this.salesforce_session_data.view;
    this.data = this.dataService.getData();
    this.document_group = this.dataService.getDocumentGroup();
    this.salesforce = this.dataService.getSalesforceData();
    if (this.loadSalesforceDataIntoService()) {
      const hide_bar = this.dataService.getUrlParamater('hide_bar');
      if (hide_bar === 'true') {
        this.hideBar = true;
      }
    }
  }

  ngOnDestroy() {
    this.GA.unsubscribe();
  }

  loadSalesforceDataIntoService() {
    const sf_token = this.salesforce_session_data.sf_token;
    const sf_refresh = this.salesforce_session_data.sf_refresh;
    const sf_org_id = this.salesforce_session_data.sf_org_id;
    const sf_user_id = this.salesforce_session_data.sf_user_id;
    const instance_url = this.salesforce_session_data.instance_url;
    const record_type = this.salesforce_session_data.record_type;
    const record_id = this.salesforce_session_data.record_id;
    const context = this.salesforce_session_data.context;

    if (sf_user_id) {
      this.GA.setKeyValue('userId', sf_user_id);
    }
    if (sf_org_id) {
      this.GA.setKeyValue('dimension1', sf_org_id);
    }

    if (this.dataService.valid_salesforce_session(this.salesforce_session_data)) {
      // set information in data service
      this.dataService.setSalesforceRefresh(sf_refresh);
      this.dataService.setSalesforceToken(sf_token);
      this.dataService.setSalesforceOrgId(sf_org_id);
      this.dataService.setSalesforceUserId(sf_user_id);
      this.dataService.setSalesforceInstanceUrl(instance_url);
      this.dataService.setSalesforceRecordType(record_type);
      this.dataService.setSalesforceRecordId(record_id);
      this.dataService.setSalesforceContext(context);
      this.dataService.setMaintenance(this.salesforce_session_data.is_maintenance);
      return true;
    }
    return false;
  }

  clickInsidePage($event: Event, commonParent: HTMLElement) {
    const allActions = commonParent.querySelectorAll('.sn-dropdown__body');
    const target = $event.target as HTMLElement;

    if (!target.classList.contains('btn-actions')) {
      for (let i = 0; i < allActions.length; i++) {
        allActions[i].classList.remove('sn-one-open');
      }
    }
  }
}
